'use strict';

var nodeify = require('../nodeify');

var crypto = require('../webcrypto');

var lengths = require('./lengths');

var hashTypes = {
  SHA1: 'SHA-1',
  SHA256: 'SHA-256',
  SHA512: 'SHA-512'
};

var sign = function sign(key, data, cb) {
  nodeify(crypto.subtle.sign({
    name: 'HMAC'
  }, key, data).then(function (raw) {
    return Buffer.from(raw);
  }), cb);
};

exports.create = function (hashType, secret, callback) {
  var hash = hashTypes[hashType];
  nodeify(crypto.subtle.importKey('raw', secret, {
    name: 'HMAC',
    hash: {
      name: hash
    }
  }, false, ['sign']).then(function (key) {
    return {
      digest: function digest(data, cb) {
        sign(key, data, cb);
      },
      length: lengths[hashType]
    };
  }), callback);
};